import React from 'react'
import Country from './components/component'
function App() {
  return (
    <div className='container'>
      <Country />
    </div>
  )
}

export default App
